import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CallRecordStateManagementService } from 'src/app/call-record-management/call-record-state-management.service';
import { StateManagementService } from 'src/app/requests-detail-view/state-managemnet.service';
import { environment } from 'src/environments/environment';
import { VIEW_TYPE } from '../../../../core/constants/view-type.enum';
import { ViewDetails } from '../../../../core/models/view-details.model';
import { SidebarMenuService } from '../../../../core/services/sidebar-menu.service';

@Component({
    selector: 'app-sidebar-menu-item',
    templateUrl: './sidebar-menu-item.component.html',
    styleUrls: ['./sidebar-menu-item.component.scss', './sidebar-menu-item.responsive.component.scss']
})
export class SidebarMenuItemComponent {
    @Input() menuItem: ViewDetails;
    @Input() activeMenuItem: ViewDetails;
    @Input() userPath: string;
    @Input() screenSize: string;
    @Input() showMobileMenu: boolean;
    @Output() showMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

    returnedRequestView = VIEW_TYPE.RETURNED_REQUESTS;
    requestTitle = 'ticketingSystem';
    generalSettings = 'generalSettings';
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private sidebarMenuService: SidebarMenuService,
        private stateServiceManagementRequest: StateManagementService,
        private stateServiceManagementCallRecord: CallRecordStateManagementService
    ) {}

    onMenuItemClick() {
        localStorage.removeItem('reportTypeId'); //remove localStorage when navigate from periodic review
        localStorage.removeItem('reportType'); //remove localStorage when navigate from periodic review
        localStorage.removeItem('reportTabId'); //remove localStorage when navigate from periodic review
        if (this.menuItem.path === 'reports' || this.menuItem.path === 'shared-reports') {
            //local when navigate to reportsReview
            localStorage.setItem('reportReview', this.menuItem.path);
        }

        if (this.menuItem.title === 'callRecord') {
            const path = [this.userPath, this.menuItem.path];
            if (!environment.production && !environment.preproduction) {
                this.router.navigate(path, { relativeTo: this.route });
            } else {
                this.openInNewTab(path);
            }
            this.stateServiceManagementCallRecord.clearState();
        } else {
            this.router.navigate([this.userPath, this.menuItem.path], {
                relativeTo: this.route
            });

            if (this.activeMenuItem !== this.menuItem) {
                this.sidebarMenuService.storeViewDetails(this.menuItem);
                this.sidebarMenuService.menuItemActive.next(true);
            }
            this.showMenu.emit(false);
            this.stateServiceManagementRequest.clearState();
        }
    }
    private openInNewTab(pathSegments: any[]): void {
        const url = this.router.serializeUrl(this.router.createUrlTree(pathSegments, { relativeTo: this.route }));
        window.open(url, '_blank');
    }
}
